import { Optional } from "common/utils/types";

import { Doctor, SubscriptionFrequency } from ".";

/** matches prescription enum CompoundComplianceRationale */
export enum Rationale {
  REDUCECOMPLIANCE = "REDUCECOMPLIANCE",
  NOTAPPROVED = "NOTAPPROVED",
  UNACHIEVABLE = "UNACHIEVABLE",
  INTOLERANCE = "INTOLERANCE",
}

/** values match choices of enum CompoundComplianceRationaleDetail */
export enum RationaleDetail {
  NEEDSFLAVOR = "NEEDS_FLAVOR",
  NEEDSCOMPOUND = "NEEDS_COMPOUND",
  NEEDSCOMBINEDMEDS = "NEEDS_COMBINED_MEDS",
  SHORTAGE = "SHORTAGE",
  NOCOMMERCIALFORM = "NO_COMMERCIAL_FORM",
  NOCOMMERCIALALTERNATIVE = "NO_COMMERCIAL_ALTERNATIVE",
  TOOSMALL = "TOO_SMALL",
  TOOLARGE = "TOO_LARGE",
  DOSAGEFORMUNSAFE = "DOSAGE_FORM_UNSAFE",
  PROTEINALLERGY = "PROTEIN_ALLERGY",
  TOPICALROUTE = "TOPICAL_ROUTE",
  PRESERVATIVESINTOLERANCE = "PRESERVATIVES_INTOLERANCE",
  DYEALLERGY = "DYE_ALLERGY",
  LACTOSEINTOLERANCE = "LACTOSE_INTOLERANCE",
  XYLITOLINTOLERANCE = "XYLITOL_INTOLERANCE",
}

/** values match choices of enum RationaleMedicalIntention */
export enum RationaleMedicalIntention {
  ABORTIFACIENT = "ABORTIFACIENT",
  ACETAMINOPHENTOXICITY = "ACETAMINOPHENTOXICITY",
  ACUTERHABDOMYOLYSIS = "ACUTERHABDOMYOLYSIS",
  ADDISONS = "ADDISONS",
  ADRENALDISEASE = "ADRENALDISEASE",
  ADRENALINSUFFICIENCY = "ADRENALINSUFFICIENCY",
  ALLERGIES = "ALLERGIES",
  ALOPECIA = "ALOPECIA",
  ALPHAAGONISTREVERSALAGENT = "ALPHAAGONISTREVERSALAGENT",
  AMYLOIDOSIS = "AMYLOIDOSIS",
  ANALGESIA = "ANALGESIA",
  ANEMIA = "ANEMIA",
  ANGINA = "ANGINA",
  ANOREXIA = "ANOREXIA",
  ANTIEMETIC = "ANTIEMETIC",
  ANTIINFLAMMATORY = "ANTIINFLAMMATORY",
  ANTIPYRETIC = "ANTIPYRETIC",
  ANXIETY = "ANXIETY",
  APHTHOUSULCER = "APHTHOUSULCER",
  ARTHRITIS = "ARTHRITIS",
  ASCARIASIS = "ASCARIASIS",
  ASPERGILLOSIS = "ASPERGILLOSIS",
  ASPIRATION = "ASPIRATION",
  ASTHMA = "ASTHMA",
  ASTHMAPROPHYLAXIS = "ASTHMAPROPHYLAXIS",
  ATOPICDERMATITIS = "ATOPICDERMATITIS",
  ATRIALFIBRILLATION = "ATRIALFIBRILLATION",
  AUTOIMMUNEDISEASES = "AUTOIMMUNEDISEASES",
  BABESIAGIBSONIINFECTIONS = "BABESIAGIBSONIINFECTIONS",
  BEHAVIORDISORDERS = "BEHAVIORDISORDERS",
  BEHAVIORALCONTROL = "BEHAVIORALCONTROL",
  BEHAVIORALISSUES = "BEHAVIORALISSUES",
  BEHAVIORALMODIFICATION = "BEHAVIORALMODIFICATION",
  BENIGNPROSTATICHYPERTROPHY = "BENIGNPROSTATICHYPERTROPHY",
  BIRTHING = "BIRTHING",
  BLADDERCONTRACTILITY = "BLADDERCONTRACTILITY",
  BLOAT = "BLOAT",
  BLOODCLOTS = "BLOODCLOTS",
  BRADYARRHYTHMIA = "BRADYARRHYTHMIA",
  BREEDING = "BREEDING",
  BRONCHITIS = "BRONCHITIS",
  BRONCHOCONSTRICTION = "BRONCHOCONSTRICTION",
  BRONCHODILATOR = "BRONCHODILATOR",
  BRONCHOSPASM = "BRONCHOSPASM",
  CALCIUMOXALATEUROLITHS = "CALCIUMOXALATEUROLITHS",
  CANCER = "CANCER",
  CANDIDIASIS = "CANDIDIASIS",
  CANINECOGNITIVEDYSFUNCTION = "CANINECOGNITIVEDYSFUNCTION",
  CANINECUSHINGS = "CANINECUSHINGS",
  CAPTUREMYOPATHY = "CAPTUREMYOPATHY",
  CARDIAC = "CARDIAC",
  CARDIACARREST = "CARDIACARREST",
  CARDIOGENICEDEMA = "CARDIOGENICEDEMA",
  CARDIOGENICPULMONARYEDEMA = "CARDIOGENICPULMONARYEDEMA",
  CARDIOMYOPATHY = "CARDIOMYOPATHY",
  CARDIOPULMONARYDISEASE = "CARDIOPULMONARYDISEASE",
  CARDIOVASCULARDISEASE = "CARDIOVASCULARDISEASE",
  CATAPLEXY = "CATAPLEXY",
  CHEMICALIMMOBILIZATION = "CHEMICALIMMOBILIZATION",
  CHRONICCOLITIS = "CHRONICCOLITIS",
  CHRONICLIVERDISEASE = "CHRONICLIVERDISEASE",
  CHRONICRENALDISEASE = "CHRONICRENALDISEASE",
  CHRONICRENALFAILURE = "CHRONICRENALFAILURE",
  COCCIDIOSIS = "COCCIDIOSIS",
  COLIC = "COLIC",
  COLITIS = "COLITIS",
  CONGESTIVEHEARTFAILURE = "CONGESTIVEHEARTFAILURE",
  CONSTIPATION = "CONSTIPATION",
  COPPERTOXICITY = "COPPERTOXICITY",
  CORNEALMELTING = "CORNEALMELTING",
  COUGH = "COUGH",
  CUSHINGS = "CUSHINGS",
  CYSTINESTONEFORMATION = "CYSTINESTONEFORMATION",
  DEGENERATIVEMYELOPATHY = "DEGENERATIVEMYELOPATHY",
  DEHYDRATION = "DEHYDRATION",
  DEPRESSION = "DEPRESSION",
  DERMATITIS = "DERMATITIS",
  DERMATOLOGICDISORDER = "DERMATOLOGICDISORDER",
  DETRUSORHYPERREFLEXIA = "DETRUSORHYPERREFLEXIA",
  DIABETES = "DIABETES",
  DIABETESADJUNCT = "DIABETESADJUNCT",
  DIABETESINSIPIDUS = "DIABETESINSIPIDUS",
  DIARRHEA = "DIARRHEA",
  DIGESTIVEDISORDERS = "DIGESTIVEDISORDERS",
  DIURESIS = "DIURESIS",
  DYSRHYTHMIAS = "DYSRHYTHMIAS",
  EARINFECTIONS = "EARINFECTIONS",
  EDEMA = "EDEMA",
  EJACULATORYDYSFUNCTION = "EJACULATORYDYSFUNCTION",
  EPILEPSY = "EPILEPSY",
  EQUINECUSHINGS = "EQUINECUSHINGS",
  EQUINEPROTOZOALMYELOENCEPHALITISEPM = "EQUINEPROTOZOALMYELOENCEPHALITISEPM",
  EQUINESHIVERS = "EQUINESHIVERS",
  ESTRUSREGULATION = "ESTRUSREGULATION",
  ESTRUSSUPPRESSANT = "ESTRUSSUPPRESSANT",
  EXCESSMUCOUS = "EXCESSMUCOUS",
  EXCESSIVESPRAYING = "EXCESSIVESPRAYING",
  EXERCISEINDUCEDBRONCHOCONSTRICTIONEIB = "EXERCISEINDUCEDBRONCHOCONSTRICTIONEIB",
  EXPECTORANT = "EXPECTORANT",
  FELINECOGNITIVEDYSFUNCTIONSYNDROME = "FELINECOGNITIVEDYSFUNCTIONSYNDROME",
  FELINEHERPESVIRUSFHV = "FELINEHERPESVIRUSFHV",
  FEVER = "FEVER",
  FLATULENCE = "FLATULENCE",
  FLUIDRETENTION = "FLUIDRETENTION",
  FOALING = "FOALING",
  FOLICACIDDEFICIENCY = "FOLICACIDDEFICIENCY",
  FROSTBITE = "FROSTBITE",
  FUNCTIONALURETHRALOBSTRUCTION = "FUNCTIONALURETHRALOBSTRUCTION",
  GALLSTONES = "GALLSTONES",
  GASBLOATING = "GASBLOATING",
  GASTRICREFLUX = "GASTRICREFLUX",
  GASTRICSTASIS = "GASTRICSTASIS",
  GASTRICULCERS = "GASTRICULCERS",
  GASTRITIS = "GASTRITIS",
  GASTROESOPHAGEALREFLUX = "GASTROESOPHAGEALREFLUX",
  GIPROKINETIC = "GIPROKINETIC",
  GLAUCOMA = "GLAUCOMA",
  GOUT = "GOUT",
  HEADSHAKING = "HEADSHAKING",
  HEARTDISEASE = "HEARTDISEASE",
  HEARTFAILURE = "HEARTFAILURE",
  HEARTWORMPROPHYLAXIS = "HEARTWORMPROPHYLAXIS",
  HEAVYMETALPOISONING = "HEAVYMETALPOISONING",
  HEPATICCIRRHOSIS = "HEPATICCIRRHOSIS",
  HEPATICFIBROSIS = "HEPATICFIBROSIS",
  HORMONEREPLACEMENT = "HORMONEREPLACEMENT",
  HYPERADRENOCORTICISM = "HYPERADRENOCORTICISM",
  HYPERKALEMICPERIODICPARALYSISHYPP = "HYPERKALEMICPERIODICPARALYSISHYPP",
  HYPERPHOSPHATEMIA = "HYPERPHOSPHATEMIA",
  HYPERTENSION = "HYPERTENSION",
  HYPERTHERMIA = "HYPERTHERMIA",
  HYPERTHYROIDISM = "HYPERTHYROIDISM",
  HYPERTRIGLYCERIDEMIA = "HYPERTRIGLYCERIDEMIA",
  HYPOADRENOCORTICISM = "HYPOADRENOCORTICISM",
  HYPOCALCEMIA = "HYPOCALCEMIA",
  HYPOGLYCEMIA = "HYPOGLYCEMIA",
  HYPOKALEMIA = "HYPOKALEMIA",
  HYPOTHERMIA = "HYPOTHERMIA",
  HYPOTHYROIDISM = "HYPOTHYROIDISM",
  IDIOPATHICSEBORRHEA = "IDIOPATHICSEBORRHEA",
  IMMUNEMEDIATEDDISEASE = "IMMUNEMEDIATEDDISEASE",
  IMMUNESTIMULANT = "IMMUNESTIMULANT",
  IMMUNOSUPPRESSIVE = "IMMUNOSUPPRESSIVE",
  INAPPROPRIATEELIMINATION = "INAPPROPRIATEELIMINATION",
  INCONTINENCE = "INCONTINENCE",
  INFECTION = "INFECTION",
  INFECTIONBACTERIAL = "INFECTIONBACTERIAL",
  INFECTIONCESTODES = "INFECTIONCESTODES",
  INFECTIONCOMBINATION = "INFECTIONCOMBINATION",
  INFECTIONENTERIC = "INFECTIONENTERIC",
  INFECTIONFUNGAL = "INFECTIONFUNGAL",
  INFECTIONMIXED = "INFECTIONMIXED",
  INFECTIONOTIC = "INFECTIONOTIC",
  INFECTIONPARASITIC = "INFECTIONPARASITIC",
  INFECTIONPROTOZOAL = "INFECTIONPROTOZOAL",
  INFECTIONVIRAL = "INFECTIONVIRAL",
  INFLAMMATION = "INFLAMMATION",
  INFLAMMATORYAIRWAYDISEASE = "INFLAMMATORYAIRWAYDISEASE",
  INFLAMMATORYBOWELDISEASE = "INFLAMMATORYBOWELDISEASE",
  INFLAMMATORYBOWELDISEASEIBD = "INFLAMMATORYBOWELDISEASEIBD",
  INFLAMMATORYLARGEBOWELDISEASE = "INFLAMMATORYLARGEBOWELDISEASE",
  INSULINOMA = "INSULINOMA",
  INTESTINALAMEBIASIS = "INTESTINALAMEBIASIS",
  INTESTINALPARASITES = "INTESTINALPARASITES",
  IRONDEFICIENCYANEMIA = "IRONDEFICIENCYANEMIA",
  JOINTHEALTH = "JOINTHEALTH",
  KERATOCONJUNCTIVITISSICCAKCS = "KERATOCONJUNCTIVITISSICCAKCS",
  KERATOMYCOSIS = "KERATOMYCOSIS",
  KIDNEYFAILURE = "KIDNEYFAILURE",
  LAMENESS = "LAMENESS",
  LAMINITIS = "LAMINITIS",
  LAXATIVE = "LAXATIVE",
  LEADPOISONING = "LEADPOISONING",
  LEUKEMIA = "LEUKEMIA",
  LYMPHOMA = "LYMPHOMA",
  LYMPHORETICULARNEOPLASMS = "LYMPHORETICULARNEOPLASMS",
  MASTCELLTUMOR = "MASTCELLTUMOR",
  MASTOCYTOMAS = "MASTOCYTOMAS",
  MEGACOLON = "MEGACOLON",
  MELANOMA = "MELANOMA",
  METABOLICALKALOSIS = "METABOLICALKALOSIS",
  MILDSEDATIVES = "MILDSEDATIVES",
  MILDTRANQUILIZER = "MILDTRANQUILIZER",
  MOTIONSICKNESS = "MOTIONSICKNESS",
  MUSCLEINFLAMMATION = "MUSCLEINFLAMMATION",
  MUSCULARSPASMS = "MUSCULARSPASMS",
  MYASTHENIAGRAVIS = "MYASTHENIAGRAVIS",
  MYOCARDIALFAILURE = "MYOCARDIALFAILURE",
  NARCOLEPSY = "NARCOLEPSY",
  NAUSEA = "NAUSEA",
  NAVICULARDISEASE = "NAVICULARDISEASE",
  NEPHROGENICDIABETESINSIPIDUS = "NEPHROGENICDIABETESINSIPIDUS",
  NEUROPATHICPAIN = "NEUROPATHICPAIN",
  NUTRITIONALDEFICIENCY = "NUTRITIONALDEFICIENCY",
  OBESITY = "OBESITY",
  OSTEOARTHRITISOA = "OSTEOARTHRITISOA",
  OVULATION = "OVULATION",
  PAIN = "PAIN",
  PARASITES = "PARASITES",
  PULMONARYEDEMA = "PULMONARYEDEMA",
  PITUITARYPARSINTERMEDIADYSFUNCTIONPP = "PITUITARYPARSINTERMEDIADYSFUNCTIONPP",
  POISONING = "POISONING",
  POSTANAESTHESIAMYOSITIS = "POSTANAESTHESIAMYOSITIS",
  PREANAESTHETIC = "PREANAESTHETIC",
  PREGNANCYMAINTENANCE = "PREGNANCYMAINTENANCE",
  PROTOZOALINTESTINALPARASITES = "PROTOZOALINTESTINALPARASITES",
  PRURITUS = "PRURITUS",
  PSEUDOPREGNANCY = "PSEUDOPREGNANCY",
  PSYCHOGENICDERMATOSES = "PSYCHOGENICDERMATOSES",
  PULMONARYHYPERTENSION = "PULMONARYHYPERTENSION",
  RHODOCOCCUSEQUI = "RHODOCOCCUSEQUI",
  REFLUX = "REFLUX",
  REFRACTORYEPILEPSY = "REFRACTORYEPILEPSY",
  REFRACTORYHYPERCALCEMIA = "REFRACTORYHYPERCALCEMIA",
  RENALTUBULARACIDOSIS = "RENALTUBULARACIDOSIS",
  RESPIRATORYARREST = "RESPIRATORYARREST",
  RESPIRATORYDEPRESSION = "RESPIRATORYDEPRESSION",
  RHEUMATOIDARTHRITIS = "RHEUMATOIDARTHRITIS",
  RHINITIS = "RHINITIS",
  SARCOID = "SARCOID",
  SARCOMA = "SARCOMA",
  SEBACEOUSADENITIS = "SEBACEOUSADENITIS",
  SEDATION = "SEDATION",
  SEIZURES = "SEIZURES",
  SEPARATIONANXIETY = "SEPARATIONANXIETY",
  SEROTONINSYNDROME = "SEROTONINSYNDROME",
  SHOCK = "SHOCK",
  SKINDISORDERS = "SKINDISORDERS",
  SKINIRRITATION = "SKINIRRITATION",
  SLEEPCYCLEDISORDERS = "SLEEPCYCLEDISORDERS",
  SUPRAVENTRICULARTACHYCARDIASVT = "SUPRAVENTRICULARTACHYCARDIASVT",
  SWELLING = "SWELLING",
  SYSTEMICMYCOSIS = "SYSTEMICMYCOSIS",
  TACHYCARDIA = "TACHYCARDIA",
  TAURINEDEFICIENCY = "TAURINEDEFICIENCY",
  THERMOREGULATION = "THERMOREGULATION",
  THROMBI = "THROMBI",
  THROMBOEMBOLICDISEASE = "THROMBOEMBOLICDISEASE",
  THRUSH = "THRUSH",
  TOPICALANAESTHESIA = "TOPICALANAESTHESIA",
  TOXOPLASMOSIS = "TOXOPLASMOSIS",
  TRITRICHOMONASFOETUS = "TRITRICHOMONASFOETUS",
  ULCERS = "ULCERS",
  URETHRALOBSTRUCTION = "URETHRALOBSTRUCTION",
  URGEINCONTINENCE = "URGEINCONTINENCE",
  URINARYINCONTINENCE = "URINARYINCONTINENCE",
  URINARYTRACTINFECTIONUTI = "URINARYTRACTINFECTIONUTI",
  URINEACIDIFICATION = "URINEACIDIFICATION",
  URINEMARKING = "URINEMARKING",
  URINESPRAYING = "URINESPRAYING",
  VENTRICULARARRHYTHMIAS = "VENTRICULARARRHYTHMIAS",
  VENTRICULARTACHYARRHYTHMIAS = "VENTRICULARTACHYARRHYTHMIAS",
  VENTRICULARTACHYCARDIA = "VENTRICULARTACHYCARDIA",
  VITAMINB12DEFICIENCY = "VITAMINB12DEFICIENCY",
  VITAMINDEFICIENCY = "VITAMINDEFICIENCY",
  VOMITING = "VOMITING",
  VONWILLEBRANDDISEASE = "VONWILLEBRANDDISEASE",
  VTACH = "VTACH",
  WARTS = "WARTS",
  WHEEZING = "WHEEZING",
  WORMS = "WORMS",
  WOUNDCARE = "WOUNDCARE",
  PROTEINURIA = "PROTEINURIA",
  CHRONICKIDNEYDISEASE = "CHRONICKIDNEYDISEASE",
  PROMOTILITY = "PROMOTILITY",
  APPETITESTIMULATION = "APPETITESTIMULATION",
  CHRONICINFLAMMATORYENTEROPATHIES = "CHRONICINFLAMMATORYENTEROPATHIES",
  ELECTROLYTESUPPLEMENTATION = "ELECTROLYTESUPPLEMENTATION",
  KERATITIS = "KERATITIS",
  CHOLESTATICDISORDERS = "CHOLESTATICDISORDERS",
  INCREASEHEPATICGLUTATHIONE = "INCREASEHEPATICGLUTATHIONE",
  NUTRITIONALSUPPLEMENT = "NUTRITIONALSUPPLEMENT",
  GIARDIA = "GIARDIA",
  SHEDDINGOFANTLERS = "SHEDDINGOFANTLERS",
  URETERALURETHRALRELAXANT = "URETERALURETHRALRELAXANT",
  ARRHYTHMIA = "ARRHYTHMIA",
  FLEAPREVENTION = "FLEAPREVENTION",
  FELINEINFECTIOUSPERITONITISFIP = "FELINEINFECTIOUSPERITONITISFIP",
  CORNEALULCER = "CORNEALULCER",
  MEDICALDEVICE = "MEDICALDEVICE",
  MUSCLERELAXATION = "MUSCLERELAXATION",
  BLEEDINGPREVENTION = "BLEEDINGPREVENTION",
  ANTIPLATELET = "ANTIPLATELET",
  ELEVATEDLIVERENZYMES = "ELEVATEDLIVERENZYMES",
  BILIARYSLUDGE = "BILIARYSLUDGE",
  IDIOPATHICCYSTITIS = "IDIOPATHICCYSTITIS",
  WEIGHTLOSS = "WEIGHTLOSS",
  ACUTEHEPATOPATHIES = "ACUTEHEPATOPATHIES",
  FOLATEDEFICIENCY = "FOLATEDEFICIENCY",
  ANTIFUNGAL = "ANTIFUNGAL",
  STRESSINDUCEDANXIETY = "STRESSINDUCEDANXIETY",
  HEPATICENCEPHALOPATHY = "HEPATICENCEPHALOPATHY",
  GIMUCOSALPROTECTANT = "GIMUCOSALPROTECTANT",
  INFLAMMATORYOCULARDISEASE = "INFLAMMATORYOCULARDISEASE",
  PITUITARYADENOMA = "PITUITARYADENOMA",
  TIEUPHORSES = "TIEUPHORSES",
  FEATHERPLUCKING = "FEATHERPLUCKING",
  HYDROCEPHALUS = "HYDROCEPHALUS",
  CHEMOTHERAPY = "CHEMOTHERAPY",
  CHIARILIKEMALFORMATIONCLM = "CHIARILIKEMALFORMATIONCLM",
  CORNEALPLAQUE = "CORNEALPLAQUE",
  VESTIBULARDISEASE = "VESTIBULARDISEASE",
  EXCESSIVEEARWAX = "EXCESSIVEEARWAX",
  REVERSALAGENT = "REVERSALAGENT",
  COPROPHAGIASTOOLEATING = "COPROPHAGIASTOOLEATING",
  DYSPHAGIA = "DYSPHAGIA",
  PANCREATITIS = "PANCREATITIS",
  EYEINFECTION = "EYEINFECTION",
  CALMINGAGENT = "CALMINGAGENT",
  MYDRIASIS = "MYDRIASIS",
  COGNITIVEDECLINE = "COGNITIVEDECLINE",
  ATHEROSCLEROSIS = "ATHEROSCLEROSIS",
  HYPERCALCEMIA = "HYPERCALCEMIA",
  TRACHEALCOLLAPSE = "TRACHEALCOLLAPSE",
  THYMOMA = "THYMOMA",
  MEGAESOPHAGUS = "MEGAESOPHAGUS",
  METABOLICBONEDISEASE = "METABOLICBONEDISEASE",
  EPIZOOTICHEMORRHAGICDISEASE = "EPIZOOTICHEMORRHAGICDISEASE",
  HEPATITIS = "HEPATITIS",
  HYPEREMICSCLERAWITHPANNUS = "HYPEREMICSCLERAWITHPANNUS",
  HYPERGLOBULINEMIAHYPOREXIA = "HYPERGLOBULINEMIAHYPOREXIA",
  MUCOTANEOUSPYODERMA = "MUCOTANEOUSPYODERMA",
  HYPERPARATHYROIDISM = "HYPERPARATHYROIDISM",
  VENTRICULARNEURALDYSFUNCTION = "VENTRICULARNEURALDYSFUNCTION",
  POLYCYTHEMIA = "POLYCYTHEMIA",
  EQUINEMETABOLICSYNDROMEEMS = "EQUINEMETABOLICSYNDROMEEMS",
  ACROMEGALY = "ACROMEGALY",
  UPPERRESPIRATORYINFECTIONURI = "UPPERRESPIRATORYINFECTIONURI",
  CALCIURIA = "CALCIURIA",
  GAITABNORMALITIES = "GAITABNORMALITIES",
  GINGIVALHYPERPLASIA = "GINGIVALHYPERPLASIA",
  BEHAVIOR_DISORDERS = "BEHAVIOR_DISORDERS",
  INFECTION_BACTERIAL = "INFECTION_BACTERIAL",
  HYPOPARATHYROIDISM = "HYPOPARATHYROIDISM",
}

/** Matches prescriptions BasePrescriptionSerializer */
export interface BasePrescription {
  id: number;
  client_notes: string;
  pharmacist_notes: string;
  allowed_uses: Optional<number>;
  days_supply: Optional<number>;
  remaining_uses: number;
  refills: Optional<number>;
  refills_display: string;
  units_display: string;
  dispensed_units_display: string;
  is_prn: boolean;
  remaining_refills_display: string;
  quantity_per_fill_display: string;
  fills_display: string;
  remaining_fills: number;
  remaining_fills_display: string;
  status: PrescriptionStatus;
  visible_status: VisiblePrescriptionStatus;
  imported_status?: PrescriptionStatus;
  prescribed_on: string;
  prescribed_by: Optional<Doctor>;
  expiration_date: Optional<string>;
  directions: string;
  inactive: boolean;
  quantity: number;
  patient_id: number;
  rationale: Optional<Rationale>;
  rationale_detail: Optional<RationaleDetail>;
  rationale_medical_intention: Optional<RationaleMedicalIntention>;
}

/** matches prescriptions PrescriptionLookupSerializer */
export interface PrescriptionLookup extends BasePrescription {
  needs_renewal: boolean;
  subscription_frequency_options: SubscriptionFrequency[];
  subscription_recommended_frequency: SubscriptionFrequency;
}

/** From prescriptions.constants PrescriptionStatus */
export enum PrescriptionStatus {
  Active = "ACTIVE",
  Draft = "DRAFT",
  Declined = "DECLINED",
  Imported = "IMPORTED",
  Inactive = "INACTIVE",
}

/** From prescriptions.constants VisiblePrescriptionStatus */
export enum VisiblePrescriptionStatus {
  Active = "ACTIVE",
  Draft = "DRAFT",
  Declined = "DECLINED",
  ImportedActive = "IMPORTED_ACTIVE",
  ExpiringSoon = "EXPIRING_SOON",
  NoFillsRemaining = "NO_FILLS_REMAINING",
  Expired = "EXPIRED",
  ImportedInactive = "IMPORTED_INACTIVE",
}
